import UserService from 'Services/user';
import DeviceService from 'Services/device';

export default {
	name: 'LoginModal',
	created() {
		this.credential.email = this.$route.query.email || '';
		this.next = this.$route.query.redirect || '/';
	},
	mounted() {
		document.documentElement.style.overflow = 'hidden';
		document.body.scroll = 'no';
	},
	data() {
		return {
			isMerchantEnabled: process.env.FEATURE_MERCHANT === 'true',
			isLoading: false,
			credential: {
				email: '',
				password: ''
			},
			isLoginModalVisible: false,
			next: '/'
		};
	},
	methods: {
		login() {
			this.$validator.validateAll().then(result => {
				if (result) {
					this.isLoading = true;
					UserService.login(this.credential)
						.then(response => {
							this.$store.commit('LOGIN_USER', { email: this.credential.email });
							this.postLogin(response.data.Confirmed);
						})
						.catch(error => {
							this.isLoading = false;
							this.errors.add({
								field: 'apierror',
								msg: 'Wrong email or password'
							});
						});
				}
			});
		},
		postLogin(isConfirmed) {
			this.$store
				.dispatch('updateDevices')
				.then(() => {
					if (isConfirmed) {
						this.$store.commit('CONFIRM_USER');
					} else {
						if (!this.next.startsWith('/confirm-account')) {
							this.next = '/confirm-account';
						}
					}
					if (this.isMerchantEnabled) {
						UserService.getSubscription()
							.then(subResponse => {
								if (subResponse.data.plan !== undefined) {
									this.$store.commit('UPDATE_SUB_INFO', {
										status: subResponse.data.status,
										plan: {
											name: subResponse.data.plan.plan_name,
											trialDays: subResponse.data.plan.trial_days
										}
									});
									if (subResponse.data.status === 'cancelled') {
										this.$store.commit('UPDATE_MAX_DEVICES', 0);
									} else {
										this.$store.commit('UPDATE_MAX_DEVICES', subResponse.data.plan.max_devices);
									}
								}
								if (
									!this.next.startsWith('/confirm-account') &&
									subResponse.data.status !== undefined &&
									subResponse.data.status.toLowerCase() === 'cancelled'
								) {
									this.next = '/plans';
								}
							})
							.finally(() => {
								this.isLoading = false;
								this.$router.push(this.next);
							});
					}
				})
				.finally(() => {
					if (!this.isMerchantEnabled) {
						this.isLoading = false;
						this.$router.push(this.next);
					}
				});
		}
	},
	destroyed() {
		document.documentElement.style.overflow = 'auto';
		document.body.scroll = 'yes';
	}
};



// WEBPACK FOOTER //
// ./app/components/login-modal/script.js